import { HttpErrorResponse } from '@angular/common/http';
import { TermSection } from '@qv-term/enums';

export class SectionChangeFailed {
  constructor(public sectionName: TermSection, public error: HttpErrorResponse) {
  }
}
